import { useEffect, useState } from "react";
import { supabase } from "../supabase";

// Company files are private (supabase/migrations/..._storage.sql): the logo in the
// `client` bucket and scenario audio in `scenario-audio`, each under the company id.
// The browser gets short-lived signed links to show or play them.

const cache = new Map<string, Promise<string | null>>();

export function signedUrl(bucket: string, path: string): Promise<string | null> {
  const key = `${bucket}/${path}`;
  let url = cache.get(key);
  if (!url) {
    url = supabase.storage
      .from(bucket)
      .createSignedUrl(path, 60 * 60)
      .then(({ data }) => data?.signedUrl ?? null);
    cache.set(key, url);
  }
  return url;
}

export function useSignedUrl(bucket: string, path: string | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    setUrl(null);
    if (!path) return;
    let live = true;
    signedUrl(bucket, path).then((u) => live && setUrl(u));
    return () => {
      live = false;
    };
  }, [bucket, path]);
  return url;
}

/** A short random part for new file names, so phones see a changed file as new. */
export function fileTag(): string {
  return crypto.getRandomValues(new Uint32Array(1))[0].toString(16).padStart(8, "0").slice(0, 6);
}
